'use strict';

Object.defineProperty(exports, "__esModule", {
    value: true
});
exports.selectMedia = exports.SELECT_MEDIA = exports.postMediaIfNeeded = exports.postMediaFailure = exports.postMediaSuccess = exports.postMediaRequest = exports.POST_MEDIA_FAILURE = exports.POST_MEDIA_SUCCESS = exports.POST_MEDIA_REQUEST = exports.fetchMediaIfNeeded = exports.failureMedia = exports.receiveMedia = exports.requestMedia = exports.invalidateMedia = exports.filterMedia = exports.INVALIDATE_MEDIA = exports.FILTER_MEDIA = exports.FAILURE_MEDIA = exports.RECEIVE_MEDIA = exports.REQUEST_MEDIA = undefined;

var _css = require('antd/lib/message/style/css');

var _message = require('antd/lib/message');

var _message2 = _interopRequireDefault(_message);

var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; /**
                                                                                                                                                                                                                                                                   * 媒体库相关 Actions
                                                                                                                                                                                                                                                                   */


var _api = require('../api');

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var REQUEST_MEDIA = exports.REQUEST_MEDIA = 'REQUEST_MEDIA';
var RECEIVE_MEDIA = exports.RECEIVE_MEDIA = 'RECEIVE_MEDIA';
var FAILURE_MEDIA = exports.FAILURE_MEDIA = 'FAILURE_MEDIA';
var FILTER_MEDIA = exports.FILTER_MEDIA = 'FILTER_MEDIA';
var INVALIDATE_MEDIA = exports.INVALIDATE_MEDIA = 'INVALIDATE_MEDIA';

var filterMedia = exports.filterMedia = function filterMedia(filter) {
    return {
        type: FILTER_MEDIA,
        filter: filter
    };
};

var invalidateMedia = exports.invalidateMedia = function invalidateMedia(filter) {
    return {
        type: INVALIDATE_MEDIA,
        filter: filter
    };
};

var requestMedia = exports.requestMedia = function requestMedia(filter) {
    return {
        type: REQUEST_MEDIA,
        filter: filter
    };
};

var receiveMedia = exports.receiveMedia = function receiveMedia(options, response) {
    var media = response.data.map(function (x) {
        return _extends({}, x, {
            id: x.upload_id
        });
    });
    return {
        type: RECEIVE_MEDIA,
        options: options,
        media: media,
        pagination: response.meta.pagination,
        received_at: Date.now()
    };
};

var failureMedia = exports.failureMedia = function failureMedia(error) {
    return {
        type: FAILURE_MEDIA,
        error: error
    };
};

var shouldFetchMedia = function shouldFetchMedia(state, filter) {
    var media = state.media.media;

    if (media.items.length === 0) {
        return true;
    }
    if (media.isFetching) {
        return false;
    }
    return true;
};

var fetchMediaIfNeeded = exports.fetchMediaIfNeeded = function fetchMediaIfNeeded(options) {
    return function (dispatch, getState) {
        if (shouldFetchMedia(getState(), options)) {
            return dispatch(function (dispatch) {
                dispatch(requestMedia(options));
                return (0, _api.fetchMedia)(options).then(function (response) {
                    return dispatch(receiveMedia(options, response.data));
                }).catch(function (error) {
                    return dispatch(failureMedia(error));
                });
            });
        }
    };
};

var POST_MEDIA_REQUEST = exports.POST_MEDIA_REQUEST = 'POST_MEDIA_REQUEST';
var POST_MEDIA_SUCCESS = exports.POST_MEDIA_SUCCESS = 'POST_MEDIA_SUCCESS';
var POST_MEDIA_FAILURE = exports.POST_MEDIA_FAILURE = 'POST_MEDIA_FAILURE';

var postMediaRequest = exports.postMediaRequest = function postMediaRequest(files) {
    return {
        type: POST_MEDIA_REQUEST,
        files: files
    };
};

var postMediaSuccess = exports.postMediaSuccess = function postMediaSuccess(response) {
    return {
        type: POST_MEDIA_SUCCESS,
        received_at: Date.now()
    };
};
var postMediaFailure = exports.postMediaFailure = function postMediaFailure(error) {
    return {
        type: POST_MEDIA_FAILURE,
        error: error
    };
};

var shouldPostMedia = function shouldPostMedia(state, filter) {
    var media = state.media.media;

    if (media.isPosting) {
        return false;
    }
    return true;
};

var postMediaIfNeeded = exports.postMediaIfNeeded = function postMediaIfNeeded(files, sign) {
    return function (dispatch, getState) {
        if (shouldPostMedia(getState())) {
            return dispatch(function (dispatch) {
                dispatch(postMediaRequest(files));
                return (0, _api.postMedia)(files, sign).then(function (response) {
                    _message2.default.success('上传成功');
                    return dispatch(postMediaSuccess(response));
                }).catch(function (error) {
                    _message2.default.error('上传失败');
                    console.error(error);
                    dispatch(postMediaFailure(error));
                });
            });
        }
    };
};

var SELECT_MEDIA = exports.SELECT_MEDIA = 'SELECT_MEDIA';

var selectMedia = exports.selectMedia = function selectMedia(id) {
    return {
        type: SELECT_MEDIA,
        id: id
    };
};


//////////////////
// WEBPACK FOOTER
// ./src/js/actions/media.js
// module id = 902
// module chunks = 0